import { SOLO_COMANDOS_MANUALES } from '../../environments/environment';

/**
 * Tooltips de los ÚNICOS comandos que el usuario puede enviar manualmente
 * cuando `SOLO_COMANDOS_MANUALES` está activo: Encender, Apagar y Pedir GPS
 * (este último solo GPE). El resto de comandos (SET de configuración y NO-SET
 * de consulta/reset) se siguen enviando desde el backend (reconciliador), pero
 * ya no se ofrecen en la UI.
 *
 * "Reaplicar perfil" NO está acá: dejó de ser un ítem del menú Comandos (no
 * manda un downlink puntual, invalida la config real para que el reconciliador
 * reenvíe el perfil) y vive como acción de fila propia, siempre visible.
 */
export const COMANDOS_MANUALES_VISIBLES = [
  'Encender',
  'Apagar',
  'Pedir GPS', // solo GPE (el botón ya se oculta para Wellness/ACTIS)
  '',
];

/**
 * Filtra los subítems de un menú "Comandos *" dejando solo los comandos
 * manuales habilitados (ver `COMANDOS_MANUALES_VISIBLES`) cuando
 * `SOLO_COMANDOS_MANUALES` está activo. Si el flag está en `false`, devuelve la
 * lista intacta (comportamiento histórico: todos los comandos visibles según
 * jerarquía de perfiles).
 *
 * Política y plan de eliminación: ver
 * `Documentación luminarias/POLITICA_COMANDOS_MANUALES_FRONT.md`.
 */
export function filtrarComandosManuales<T extends { tooltip?: string }>(
  children: T[],
): T[] {
  if (!SOLO_COMANDOS_MANUALES) return children;
  return children.filter((c) =>
    COMANDOS_MANUALES_VISIBLES.includes(c.tooltip ?? ''),
  );
}
